import adminStoreModules from '@admin/store/storeModules'
const storeModules = {
  ...adminStoreModules,
  im: require("./IMstore.js").default, //腾讯im通讯
  trtc: require("../pages/commonPage/meeting/mettingStore.js").default, //mettingStore 全局
  login: require("./loginStore.js").default, //登录之后的 store
  message: require("./message/index.js").default, //消息通讯message store
  mobile: require("./mobile.js").default, // 手机端
  promiseAlert: require("./promiseAlert.js").default, // 手机端
  //首页
  index: require("../pages/index/store/state").default
};

export default storeModules;



// WEBPACK FOOTER //
// ./src/match/store/storeModules.js